import { categoryCRUDUrl, shopAddUrl, shopCRUDUrl, shopListGetUrl } from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getShops = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(shopListGetUrl + `${query || ""}`, config);

    return response;
};

export const postShop = async (data) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(shopAddUrl, data, config);
    return response;
};

export const patchShop = async ({ data, id }) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.patch(shopAddUrl + id + "/", data, config);
    return response;
};

export const patchShopCrud = async ({ data, id }) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.patch(shopCRUDUrl + id + "/", data, config);
    return response;
};

export const getCategories = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(categoryCRUDUrl + "?page_size=40", config);

    return response;
};
